import React from 'react';
import { components, ControlProps, OptionTypeBase } from 'react-select';

const Control = <OptionType extends OptionTypeBase, IsMulti extends boolean>({
  children,
  selectProps,
  ...props
}: ControlProps<OptionType, IsMulti>) => {
  const { left } = selectProps;

  return (
    <components.Control {...props} selectProps={selectProps}>
      {left}
      {children}
    </components.Control>
  );
};

export default Control;
